import SucceedCheckmark from "@app/components/core/SucceedCheckmark"
import Button from "@app/components/move2Library/Button/Button"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import { useEffect } from "react"
import { TabletSaunaBoatBase } from "../TabletSaunaBoatBase"

export default function TableSaunaBooking4() {
	const { push } = useCustomNavigation()

	useEffect(() => {
		let timer = setTimeout(() => {
			push("/tablet-sauna-boat-1")
		}, 10000)
		return () => clearTimeout(timer)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<TabletSaunaBoatBase>
			<div className="flex-1 flex flex-center flex-column">
				<div className="f1 mb-5 color-fg-success text-center">Buchung erfolgreich!</div>
				<div className="flex flex-center">
					<SucceedCheckmark size={150} />
				</div>
			</div>
			<div className="mt-auto flex">
				<Button style="secondary" className="ml-auto" onClick={() => push("/tablet-sauna-boat-1")}>
					Neue Buchung
				</Button>
			</div>
		</TabletSaunaBoatBase>
	)
}
